enum InterventionFieldNames {
  Asset = 'asset',
  Assignee = 'assignee',
  AssigneeList = 'assigneeList',
  AttachmentsAttached = 'attachmentsAttached',
  Category = 'category',
  Code = 'code',
  DepartmentLinks = 'departmentLinks',
  Description = 'description',
  DurationTime = 'durationTime',
  EstimatedDate = 'estimatedDate',
  EstimatedTime = 'estimatedTime',
  Id = 'id',
  LogisticTime = 'logisticTime',
  Name = 'name',
  Priority = 'priority',
  Site = 'site',
  SiteArea = 'siteArea',
  Status = 'status',
  Supervisor = 'supervisor',
  Task = 'task',
  DetailsTitle = 'details-title',
  SubjectsTitle = 'subjects-title',
  DepartmentsAndVisibilityTitle = 'departments-and-visibility-title',
  AssignationTitle = 'assignation-title',
  TimingTitle = 'timing-title',
}

export default InterventionFieldNames;
